import { Stack, Typography } from '@mui/material'
import { com } from '@eidu/form'
import { useCallback, useContext, useEffect, useState } from 'react'
import EntityTypeRepository from '../../io/EntityTypeRepository'
import { EntityTypesContext } from '../../io/context/EntityTypes'
import getSemanticLinks from '../../io/api/analytics/getSemanticLinks'
import EntityTypesStack from '../../components/layout/EntityTypesStack'
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import SemanticLink = com.eidu.sharedlib.entity.analytics.SemanticLink

type SemanticsPageContentProps = {
  entityTypes: readonly EntityType[]
  semanticLinks: readonly SemanticLink[]
  onSemanticLinksChange: () => void
}

const SemanticsPageContent = ({ entityTypes, semanticLinks, onSemanticLinksChange }: SemanticsPageContentProps) => (
  <Stack paddingX={3} paddingY={3} spacing={3}>
    <Typography variant="h4">Semantics</Typography>
    <EntityTypesStack
      kind={EntityTypeKind.School}
      entityTypes={entityTypes}
      semanticLinks={semanticLinks}
      onSemanticLinksChange={onSemanticLinksChange}
    />
    <EntityTypesStack
      kind={EntityTypeKind.User}
      entityTypes={entityTypes}
      semanticLinks={semanticLinks}
      onSemanticLinksChange={onSemanticLinksChange}
    />
  </Stack>
)

type SemanticsPageProps = {
  entityTypeRepository: EntityTypeRepository
}

const SemanticsPage = ({ entityTypeRepository }: SemanticsPageProps) => {
  const entityTypes = entityTypeRepository.useSortedEntityTypes() ?? []

  const [semanticLinks, setSemanticLinks] = useState<readonly SemanticLink[]>([])

  const handleSemanticLinksChange = useCallback(() => {
    getSemanticLinks().then(
      (links) => {
        setSemanticLinks(links)
      },
      (error) => {
        console.error(`Error when getting semantic links: ${error}`)
      }
    )
  }, [])

  useEffect(() => {
    handleSemanticLinksChange()
  }, [handleSemanticLinksChange])

  return (
    <>
      <SemanticsPageContent
        entityTypes={entityTypes}
        semanticLinks={semanticLinks}
        onSemanticLinksChange={handleSemanticLinksChange}
      />
    </>
  )
}

const SemanticsPageRoute = () => {
  const entityTypeRepository = useContext(EntityTypesContext)
  return <SemanticsPage entityTypeRepository={entityTypeRepository} />
}

export default SemanticsPageRoute

export { SemanticsPageContent }
